import useDynamicDropdown from './useDynamicDropdown'

const useBrokerScore = () => {
  const {
    data: scores,
    loading,
    update,
    deleteItem: deleteLeadStatus,
    updateItem: updateSpecific,
    formattedData: formattedScores
  } = useDynamicDropdown('brokerScore')

  return {
    scores,
    loading,
    update,
    deleteLeadStatus,
    updateSpecific,
    formattedScores
  }
}

export default useBrokerScore
